<template>
    <div class="SystemQuiz">
        <div class="image" :style="{ backgroundColor: imageBackgroundColor }">
            <div class="quizIcon" :style="{ backgroundColor: iconBackgroundColor }">
                <svgicon class="icon" icon="activities/quiz" />
            </div>
        </div>
        <div class="content">
            <div class="gray-text">
                {{ $t('title') }}
            </div>
            <div class="bold-title"> Lifekey quiz </div>
            <div class="links-wrapper">
                <a href="#">View All</a>
                <a href="#">Practice All</a>
            </div>
        </div>
        <a href="#" class="button-blue">Locked</a>
        <StepBullet :progress="0" :current="current" :color="theme.color" icon="flag-with-checkmark" />
    </div>
</template>

<translations>
    title: System Quiz
    title_no: System Quiz
</translations>

<script>
import Color from 'color';
import StepBullet from '@/modules/course/components/StepBullet';

export default {
    components: {
        StepBullet
    },

    props: {
        current: {
            type: Boolean,
            default: false
        }
    },

    inject: ['theme'],

    computed: {
        imageBackgroundColor() {
            return this.theme.color;
        },

        iconBackgroundColor() {
            return Color(this.theme.color).lighten(0.2).hex();
        },

        quizType() {
            return this.journey.quiz ? this.journey.quiz.generator : '';
        }
    }
};
</script>

<style lang="scss" scoped>
.SystemQuiz {
    position: relative;
    border-radius: 1em;
    background-color: white;
    display: flex;
    align-items: center;
    padding-bottom: 1.5em;
    @media (max-width: 530px) {
        border-radius: 0.5em;
    }
}
.image {
    min-width: 95px;
    min-height: 95px;
    border-radius: 13.3405px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 530px) {
        min-width: 48px;
        min-height: 48px;
        border-radius: 10px;
    }
}

.button-blue {
    @media (max-width: 884px) {
        display: none;
    }
}

.quizIcon {
    $size: 5em;
    width: $size;
    height: $size;
    background-color: rgba(white, 0.2);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 530px) {
        width: 1.5em;
        height: 1.5em;
    }

    .svg-icon {
        $size: 50%;
        width: $size;
        height: $size;
        fill: white;
    }
}

.gray-text {
    @media (max-width: 530px) {
        font-size: 14px;
    }
}
.content {
    padding-left: 25px;
    flex: 1;
    align-self: stretch;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .links-wrapper {
        margin-top: 0.7em;
        a {
            font-size: 16px;
            color: #5983f7;
            text-decoration: none;

            &:first-of-type {
                color: rgba(114, 114, 114, 0.5);
                margin-right: 1.5em;
            }
        }
    }

    @media (max-width: 530px) {
        padding-left: 1em;
    }
}

.bold-title {
    margin-top: 5px;
    @media (max-width: 530px) {
        font-size: 16px;
        margin-top: 0;
    }
}

.spacer {
    flex: 1;
}

.text {
    margin-top: 0.3em;
    color: rgba(black, 0.7);
}

.buttonContainer {
    display: flex;
    margin-top: 1em;
}
.button {
    border-radius: 2em;
    color: white;
    padding: 0.8em 1em;
    display: flex;
    align-items: center;
}
.icon-arrow {
    $size: 1em;
    width: $size;
    height: $size;
    fill: white;
    margin-left: 1em;
}

.StepBullet {
    display: none;
    position: absolute;
    top: -0.5em;
    right: -0.5em;
}
</style>
